import { render, staticRenderFns } from "./viewDetail.vue?vue&type=template&id=a93fec88"
import script from "./viewDetail.vue?vue&type=script&lang=js"
export * from "./viewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports